(async()=>{
    var e = await import(window.theme.modules.baseComponent);
    customElements.define("product-qty", class extends e.default {
        render() {
            this.currentVariant = +this.getAttribute("variant-id"),
            this.listenTo("variantChange", (e,t)=>{
                this.currentVariant = t.variant.id,
                this._rerender(t)
            }
            ),
            this.listenTo("qtyStatusUpdate", (e,t)=>{
                this.currentVariant === +t.variantId && this._rerender(t)
            }
            , !1)
            
            this.addEventListener("change", function(){
              var input = document.querySelector("[data-variant-quantity-input]");
                //debugger;
              if(input){
              input.value = this.querySelector("select").value;
              }
            })
            
  //           For +/- buttons
  //           document.addEventListener('click', function(e){
  // 	let el = e.target;
    
  //   if(el.classList.contains('product-page-controls-item') || el.closest('.product-page-controls-item')) {
  //     if(!el.classList.contains('product-page-controls-item')) {
  //     	el = el.closest('.product-page-controls-item');
  //     }
  //   e.preventDefault();
  //     let parentEl = el.closest('.product-page-controls');
  //     let qtyInputEl = parentEl.querySelector('.product-page-controls-input');
  //     let qty_val = qtyInputEl.value * 1;
  //     if(el.classList.contains('plus_btn')) {
  //       qty_val = qty_val + 1;
  //     } else {
  //       qty_val = qty_val - 1;
  //     }
  //     if(qty_val <= 1) {
  //       qty_val = 1;
  //     }
  //     qtyInputEl.value = qty_val;
  //     var changeEvent = new Event("change", {"bubbles": true});
  //     qtyInputEl.dispatchEvent(changeEvent);
      
      
  //   }
  // });
            
        }
        _rerender(e) {
            const t = e.html.querySelector("product-qty");
            e = this.querySelector("select")?.value;
          
            if (e) {
                const r = t.querySelector(`option[value="${e}"]`);
                r && r.setAttribute("selected", !0);
              var input = document.querySelector("[data-variant-quantity-input]");
              if(input){
              input.value = e;
              }
        }else{
              var input = document.querySelector("[data-variant-quantity-input]");
              if(input){
              input.value = 1;
              }
        }
            this.replaceChildren(...t.cloneNode(!0).childNodes)
        }
    }
    )
}
)();